import React, { useMemo } from 'react';
import Paper from '@material-ui/core/Paper';

import ActivityCard from 'components/ActivityCard';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';

import { useStyles } from '../styles';

interface IProps {
  activityReport: any; // TODO: improve this
  currentTeam: any; // TODO: improve this
  withoutPaper?: boolean;
}

const ChannelsCounter: React.FC<IProps> = ({ activityReport, currentTeam, withoutPaper }) => {
  const classes = useStyles();

  const channelsActiveCounter = useMemo(() => {
    if (!activityReport) return { number: 0 };
    let totalActiveChannels: any;
    if (currentTeam.teamId) {
      totalActiveChannels =
        currentTeam.channels
          .filter((c: any) => !c.isArchived && c.monitored)
          .map((c: any) => c.channelId) || [];
    } else {
      totalActiveChannels = currentTeam.msChannels.map((c: any) => c.channelId) || [];
    }
    return {
      number:
        (activityReport.metricsGauges.length &&
          activityReport.metricsGauges[0].channels.filter((c: any) =>
            totalActiveChannels.includes(c)
          ).length) ||
        0,
      outOf: totalActiveChannels.length,
    };
  }, [activityReport]);

  return (
    <>
      {!withoutPaper ? (
        <Paper className={classes.paper}>
          <ActivityCard
            icon={<DynamicFeedIcon style={{ marginRight: '5px' }} />}
            title={'Active Channels'}
            data={channelsActiveCounter.number}
            outOf={channelsActiveCounter.outOf}
            share={(channelsActiveCounter.number * 100) / channelsActiveCounter.outOf}
          />
        </Paper>
      ) : (
        <ActivityCard
          icon={<DynamicFeedIcon style={{ marginRight: '5px' }} />}
          title={'Active Channels'}
          data={channelsActiveCounter.number}
          outOf={channelsActiveCounter.outOf}
          share={(channelsActiveCounter.number * 100) / channelsActiveCounter.outOf}
        />
      )}
    </>
  );
};

export { ChannelsCounter };
